  // Script for tree upsell functionality
  // change the price, amount of trees, and the heading on slider change 
  let productQuantity = 1
  const treeUpsellButton = document.querySelector(".cart-upsell-btn")
  const TreeId = document.querySelector("[data-upsell-id-tree]").dataset.upsellIdTree

  // Listening to add to cart
  treeUpsellButton?.addEventListener("click", () => {
    sendTreeToCart()
  })

  const sendTreeToCart = () => {
      const add = "add"
      makeTreeFetch(add,TreeId,productQuantity)
      window.ReloadCartHTML()
      treeUpsellButton.classList.add('disabled')
      treeUpsellButton.innerText = "Thank you!"
  }

  const makeTreeFetch = (path, id, quantity) => {
      let item = {
        id: id,
        quantity: quantity
      }

    let config = { 
      headers: {
        "content-type": "application/json",
      },
      "method": "POST",
      "body": JSON.stringify(item)
    }
      
    fetch(`/cart/${path}.js`, config)
    .then((response) => {})
    .then(() => {})
    .catch(error => {
        console.log(error)
      })
  }